import Select from "react-select";
import type { SelectValue } from "ui-kit/src/MultipleSelect/types";
import { _ } from "i18n";
import type { Keys } from "i18n/locales/types";

type SelectOption = {
    value: string | number;
    label: string;
}

interface FilterSelectProps {
    options: SelectOption[];
    value: SelectValue | null;
    onChange: (value: SelectValue) => void;
    placeholder: string;
    isLoading?: boolean;
}

export const FilterSelect: React.FC<FilterSelectProps> = ({
    options,
    value,
    onChange,
    placeholder,
    isLoading = false,
}) => (
    <div className="select-container">
        <Select
            classNamePrefix="api-react-select"
            className="react-select"
            options={options}
            isClearable
            isLoading={isLoading}
            value={value}
            placeholder={_(placeholder as keyof Keys).toUpperCase()}
            onChange={onChange}
        />
    </div>
); 